var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.6289,
    r: 15.04,
    fill: "#FF4B4B",
    stroke: "white",
    strokeWidth: 1.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00391 10.625C8.10587 11.523 8.10587 12.9789 9.00391 13.877L12.2559 17.1289L9.00391 20.3809C8.10587 21.2789 8.10587 22.7348 9.00391 23.6328C9.90194 24.5309 11.3578 24.5309 12.2559 23.6328L15.5078 20.3809L18.7598 23.6328C19.6578 24.5309 21.1137 24.5309 22.0117 23.6328C22.9098 22.7348 22.9098 21.2789 22.0117 20.3809L18.7598 17.1289L22.0117 13.877C22.9098 12.9789 22.9098 11.523 22.0117 10.625C21.1137 9.72696 19.6578 9.72696 18.7598 10.625L15.5078 13.877L12.2559 10.625C11.3578 9.72696 9.90194 9.72696 9.00391 10.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.293d0e6df4995af75cba5d1c72596727.svg";
export { ForwardRef as ReactComponent };